import { render, staticRenderFns } from "./Council.vue?vue&type=template&id=74c85ef8&scoped=true"
import script from "./Council.vue?vue&type=script&lang=js"
export * from "./Council.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c85ef8",
  null
  
)

export default component.exports